import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import generateCustomPizzaPrice from '../../utils/generateCustomPizzaPrice';
import MenuItemInformation from '../common/menuitem/MenuItemInformation';
import MenuItemChoiceSelection from '../common/menuitem/MenuItemChoiceSelection';
import MenuItemInstructions from '../common/menuitem/MenuItemInstructions';
import MenuItemSubmitButton from '../common/menuitem/MenuItemSubmitButton';
import MenuItemAdded from '../common/menuitem/MenuItemAdded';
import { ModalCloseButton } from '../common/ModalCloseButton';
import { 
    cartItemReset, 
    cartItemUpdatePizzaType,
    cartItemUpdateMaxToppings, 
    cartItemUpdateCrust, 
    cartItemUpdateSauce, 
    cartItemUpdatePrice } from '../../actions/cartItem';
import getToppingDetails from '../../selectors/customToppingDetails';

import { closeCustomPizza } from '../../actions/modals';

import { setCartPanel, setPizzaPanel } from '../../actions/panels';

import ViewMaxToppings from './common/ViewMaxToppings';
import ViewSizes from './common/ViewSizes';
import ViewToppings from './common/ViewToppings';
import ViewCrusts from './common/ViewCrusts';
import ViewSauces from './common/ViewSauces';

class ViewCustomPizzaModal extends React.Component {

    constructor(props) {
        super(props);

        this.showCompleted = this.showCompleted.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCart = this.handleCart.bind(this);
    }

    showCompleted() {
        this.props.dispatch(setPizzaPanel('completed'));
    }

    handleClose() {
        this.props.dispatch(closeCustomPizza());
    }

    handleCart() {
        this.props.dispatch(setCartPanel(''));
        this.props.history.push('/'+this.props.sitename+'/'+this.props.locationId+'/cart');
        this.props.dispatch(closeCustomPizza());
    }

    printToppingsSizePrice(max_toppings, size_id) {
        if (this.props.currentLocation.customPizzas) {
            for (let i = 0; i < this.props.currentLocation.customPizzas.length; i++) {
                if (this.props.currentLocation.customPizzas[i].max_toppings == max_toppings) {
                    for (let j = 0; j < this.props.currentLocation.customPizzas[i].prices.length; j++) {
                        if (this.props.currentLocation.customPizzas[i].prices[j].size_id == size_id) {
                            return this.props.currentLocation.customPizzas[i].prices[j].price;
                        }
                    }
                }
            }
        }
    }

    printCrustName(cid, pid) {
        for (let i = 0; i < this.props.currentLocation.customCrusts.length; i++) {
            if (this.props.currentLocation.customCrusts[i].id == cid) {

                let theCrustName = this.props.currentLocation.customCrusts[i].name;
                for (let j = 0; j < this.props.currentLocation.customCrusts[i].prices.length; j++) {
                    
                    if (this.props.currentLocation.customCrusts[i].prices[j].size_id == pid && parseFloat(this.props.currentLocation.customCrusts[i].prices[j].price) > 0) {
                        theCrustName += " - "+this.props.currentLocation.customCrusts[i].prices[j].price;
                    }
                }

                return theCrustName;
            }
        }
    }

    printSauceName(sid, pid) {
        for (let i = 0; i < this.props.currentLocation.customSauces.length; i++) {
            if (this.props.currentLocation.customSauces[i].id == sid) {
                let theSauceName = this.props.currentLocation.customSauces[i].name;
                for (let j = 0; j < this.props.currentLocation.customSauces[i].prices.length; j++) {
                    
                    if (this.props.currentLocation.customSauces[i].prices[j].size_id == pid && parseFloat(this.props.currentLocation.customSauces[i].prices[j].price) > 0) {
                        theSauceName += " - "+this.props.currentLocation.customSauces[i].prices[j].price;
                    }
                }

                return theSauceName;
            }
        }
    }

    renderCustomPizzaChoices() {
``
        return (
            <div>
                <div className="selectionTitleText">
                    <p>How do you want it?</p>
                </div>

                <MenuItemChoiceSelection
                    key='max_toppings'
                    onChoicePress={() => this.props.dispatch(setPizzaPanel('max_toppings'))}
                    selectionText={this.props.cartItem.max_toppings}
                >
                    How Many Toppings?
                </MenuItemChoiceSelection>

                <MenuItemChoiceSelection
                    key='price'
                    onChoicePress={() => this.props.dispatch(setPizzaPanel('sizes'))}
                    selectionText={this.props.cartItem.price_name+" - "+this.printToppingsSizePrice(this.props.cartItem.max_toppings, this.props.cartItem.price_id)}
                >
                    Size
                </MenuItemChoiceSelection>

                <MenuItemChoiceSelection
                    key='toppings'
                    onChoicePress={() => this.props.dispatch(setPizzaPanel('toppings'))}
                    selectionText={this.props.toppingDetails}
                >
                    Toppings
                </MenuItemChoiceSelection>

                {(this.props.currentLocation.customCrusts && this.props.currentLocation.customCrusts.length > 1) && (<MenuItemChoiceSelection
                    key='crusts'
                    onChoicePress={() => this.props.dispatch(setPizzaPanel('crusts'))}
                    selectionText={this.printCrustName(this.props.cartItem.crust_id, this.props.cartItem.price_id)}
                >
                    Crust
                </MenuItemChoiceSelection>)}

                {(this.props.currentLocation.customSauces && this.props.currentLocation.customSauces.length > 1) && (<MenuItemChoiceSelection
                    key='sauces'
                    onChoicePress={() => this.props.dispatch(setPizzaPanel('sauces'))}
                    selectionText={this.printSauceName(this.props.cartItem.sauce_id, this.props.cartItem.price_id)}
                >
                    Sauce
                </MenuItemChoiceSelection>)}
                
            </div>
        );
    }

    renderActivePanel() {
        switch(this.props.curPanel) {

            case 'max_toppings':
                return this.renderMaxToppings();

            case 'sizes':
                return this.renderSizes();

            case 'toppings':
                return this.renderToppings();

            case 'crusts':
                return this.renderCrusts();

            case 'sauces':
                return this.renderSauces();

            case 'completed':
                return this.renderCompleted();
            
            default:
                return this.renderInfo();
        }
    }

    renderMaxToppings() {
        return <ViewMaxToppings />;
    }

    renderSizes() {
        return <ViewSizes />
    }

    renderCrusts() {
        return <ViewCrusts />
    }
    
    renderSauces() {
        return <ViewSauces />
    }

    renderToppings() {
        return <ViewToppings />;
    }

    renderCompleted() {
        return (
            <MenuItemAdded 
                item={this.props.pizza} 
                handleClose={this.handleClose}
                handleCart={this.handleCart}
            />
        );
    }

    renderInfo() {
        return (
            <div>
                <div className="menu-item-window">
                    <MenuItemInformation isCustomPizza={true} />

                    {this.renderCustomPizzaChoices()}

                    <MenuItemInstructions 
                        placeholder="Any special instructions?"
                    />
                    <p className="disclaimer">
                        Please note: Addons and substitutions requested via special
                        instructions that are subject to extra pricing may not be honoured by the 
                        restaurant.
                    </p>
                </div>
                <div className="fixed-wrapper-for-add-to-order">
                    <MenuItemSubmitButton
                        itemtype="pizza"
                        price={generateCustomPizzaPrice(this.props.currentLocation, this.props.cartItem)}
                        showCompleted={this.showCompleted}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <Modal
                isOpen={this.props.open}
                contentLabel="Build Your Own Pizza"
                overlayClassName="modal-overlay"
                className="modal-window"
            >
                <div>
                    <ModalCloseButton 
                        clickAction={() => { this.props.dispatch(closeCustomPizza()) }} 
                    />

                    {this.renderActivePanel()}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        curPanel: state.panels.pizza,
        pizza: state.currentMenuItem.item,
        cartItem: state.cartItem,
        currentLocation: state.currentLocation.info,
        toppingDetails: getToppingDetails(state.cartItem, state.currentLocation.info.toppings),
        open: state.modals.customPizza
    };
};

export default connect(mapStateToProps)(ViewCustomPizzaModal);
